import ApiConfig from "../Config";
import apiService from "../services/apiService";

const marketingservice = {
  getMarketingAtt: (token, params) =>
    apiService.get(ApiConfig.getMarketingAttribution, {
      headers: {
        "x-access-token": token,
      },
      params,
    }),
};
export default marketingservice;
